/** Form fields for DocTypeEditModal (kept separate for line budget). */
import { HUB_DOC_TYPES } from './DocUploadModal'
import MoneyInput from '../MoneyInput'

const fieldStyle = {
  width: '100%', marginBottom: 12, padding: '8px 10px',
  border: '1px solid var(--line2)', borderRadius: 'var(--rs)',
  fontSize: 13, background: 'var(--surface)', color: 'var(--ink)',
} as const

export interface DocTypeEditFieldsProps {
  docType: string
  setDocType: (v: string) => void
  amountStr: string
  setAmountStr: (v: string) => void
  expiresOn: string
  setExpiresOn: (v: string) => void
  showAmount: boolean
  needAmount: boolean
  isInsurance: boolean
  error: string | null
  busy: boolean
  dirty: boolean
  onClose: () => void
  onSave: () => void
}

export default function DocTypeEditFields({
  docType, setDocType, amountStr, setAmountStr, expiresOn, setExpiresOn,
  showAmount, needAmount, isInsurance, error, busy, dirty, onClose, onSave,
}: DocTypeEditFieldsProps) {
  return (
    <>
      <label style={{ display: 'block', fontSize: 11, color: 'var(--ink4)', marginBottom: 4 }}>Type</label>
      <select
        data-testid="hub-doc-type-edit-select"
        value={docType}
        onChange={(e) => setDocType(e.target.value)}
        style={fieldStyle}
      >
        {HUB_DOC_TYPES.map((t) => (
          <option key={t.value} value={t.value}>{t.label}</option>
        ))}
      </select>

      {showAmount ? (
        <>
          <label style={{ display: 'block', fontSize: 11, color: 'var(--ink4)', marginBottom: 4 }}>
            Amount{needAmount ? ' (required)' : ''}
          </label>
          <MoneyInput
            placeholder="0.00"
            data-testid="hub-doc-type-edit-amount"
            value={amountStr}
            onChange={setAmountStr}
            className="aria-chat-money"
            style={{ ...fieldStyle, fontFamily: "'JetBrains Mono', monospace" }}
          />
        </>
      ) : null}

      {isInsurance ? (
        <>
          <label style={{ display: 'block', fontSize: 11, color: 'var(--ink4)', marginBottom: 4 }}>
            Insurance expiry (optional)
          </label>
          <input
            type="date"
            data-testid="hub-doc-type-edit-expires"
            value={expiresOn}
            onChange={(e) => setExpiresOn(e.target.value)}
            style={fieldStyle}
          />
        </>
      ) : null}

      {error ? (
        <p style={{ margin: '0 0 12px', fontSize: 12, color: 'var(--red)' }}>{error}</p>
      ) : null}

      <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
        <button className="btn-ghost" type="button" disabled={busy} onClick={onClose}>
          Cancel
        </button>
        <button
          className="btn"
          type="button"
          disabled={busy || !dirty}
          data-testid="hub-doc-type-edit-save"
          onClick={onSave}
        >
          {busy ? 'Saving…' : 'Save'}
        </button>
      </div>
    </>
  )
}
